export const bzAgendaSettings = {
    "filters": [
        {
            "tags": [
                {
                    "name": "Summit Stage",
                    "id": 414717
                },
                {
                    "name": "Future Stage",
                    "id": 414718
                },
                {
                    "name": "Inspiration Workshop Room",
                    "id": 437516
                }
            ],
            "visible": true,
            "name": "Stages",
            "id": 68770,
            "type": "multi"
        },
        {
            "tags": [
                {
                    "name": "GRIF",
                    "id": 414720
                },
                {
                    "name": "FHS",
                    "id": 414721
                },
                {
                    "name": "AHIC",
                    "id": 414722
                },
                {
                    "name": "Experiences",
                    "id": 414723
                },
                {
                    "name": "Workshop & Pitches",
                    "id": 414724
                },
                {
                    "name": "Networking",
                    "id": 432689
                }
            ],
            "visible": true,
            "name": "Tracks",
            "id": 68771,
            "type": "multi"
        }
    ],
    "eventId": 443032,
    "links": [
        {
            "rel": "self",
            "href": "https://api.bizzabo.com/api/agenda/settings"
        }
    ]
}